import { Mark, mergeAttributes } from "@tiptap/core";

export const DocumentBackgroundColor = Mark.create({
    name: "documentBackgroundColor",

    addOptions() {
        return {
            HTMLAttributes: {},
        };
    },

    addAttributes() {
        return {
            backgroundColor: {
                default: null,
                parseHTML: (element) => element.style.backgroundColor || null,
                renderHTML: (attributes) => {
                    if (!attributes.backgroundColor) {
                        return {};
                    }

                    return {
                        style: `background-color: ${attributes.backgroundColor}`,
                    };
                },
            },
        };
    },

    parseHTML() {
        return [
            {
                style: "background-color",
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return ["span", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },

    addCommands() {
        return {
            setBackgroundColor:
                (color: string) =>
                ({ chain }) => {
                    return chain().setMark("documentBackgroundColor", { backgroundColor: color }).run();
                },
            unsetBackgroundColor:
                () =>
                ({ chain }) => {
                    return chain().unsetMark("documentBackgroundColor").run();
                },
        };
    },
});
